module.exports = __webpack_public_path__ + "static/media/bake.10da0f2b.m4a";